<template>
  <!--
    D : 판매종료시 추가해주세요.
    tr태그에 class="is-soldout" 추가
    class="c-product-card"에 is-card-soldout 클래스 추가
    class="c-product-card"에 is-soldout 클래스 추가 후 각 form에는 disabled 추가
    class="c-counter"에 class="is-soldout" 추가 후 각 form에는 disabled 추가
  -->
  <tr :class="{ 'is-soldout': props.item.mmsta == 'N' }">
    <td>
      <!-- D : 판매종료시 is-card-soldout 추가 -->
      <div
        class="c-product-card type-horizontal"
        :class="{ 'is-card-soldout': props.item.mmsta == 'N' }"
      >
        <div class="product-thumb">
          <button
            type="button"
            class="thumb-button"
            @click="emit('detail', props.item)"
          >
            <div class="product-img">
              <img
                v-if="isNoPcImage"
                src="@/assets/images/common/img_no_product.svg"
                alt="No Image"
              />
              <img
                v-else
                :src="imageFilePath"
                alt=""
                @error="() => (imageErrorYn = true)"
              />
            </div>
            <div class="thumb-bottom">
              <p class="text">제품상세</p>
              <i class="c-icon icon-plus"></i>
            </div>
          </button>
        </div>
        <div class="product-info">
          <div v-show="!productBadgeEmptyYn" class="c-product-badge">
            <span v-if="props.item.setgdYn === 'Y'" class="badge type-skyblue">
              SET 제품
            </span>

            <span v-if="props.item.zzlqdCls == 'A'" class="badge type-purple">
              주제
            </span>
            <span v-if="props.item.zzlqdCls == 'B'" class="badge type-mint">
              경화제
            </span>
            <span v-if="props.item.zzlqdCls == 'C'" class="badge type-blue">
              경화촉진제
            </span>
            <span v-if="props.item.zzlqdCls == 'D'" class="badge type-violet">
              회석제
            </span>

            <span v-if="props.item.zzlqdtyCls == 'A'" class="badge type-olive">
              1액형
            </span>
            <span v-if="props.item.zzlqdtyCls == 'B'" class="badge type-olive">
              2액형
            </span>
            <span v-if="props.item.zzlqdtyCls == 'C'" class="badge type-olive">
              3액형
            </span>
          </div>
          <div class="c-product-category">
            <span class="path">{{ props.item.prodh1t }}</span>
            <span class="path">{{ props.item.prodh2t }}</span>
            <span class="path">{{ props.item.prodh3t }}</span>
          </div>
          <div class="product-code">{{ props.item.matnr }}</div>
          <strong class="product-name">{{ props.item.zzmaktx }}</strong>
        </div>
        <div class="card-dim">
          <p class="text">담당영업사원 통한 주문품 주문건</p>
          <i class="c-icon icon-check-circle"></i>
        </div>
      </div>
      <!-- // D : 판매종료시 is-card-soldout 추가 -->
    </td>
    <td>{{ props.item.zztotalQty }}</td>
    <td>{{ Number(props.item.goodsQty) }}</td>
    <td class="ar">{{ Number(props.item.goodsPrc).toLocaleString() }}원</td>
    <template v-if="props.item.statCd == '0'"><td>-</td></template>
    <template v-else>
      <td>
        {{ Number(props.item.goodsQty - props.item.canQty) }}
      </td>
    </template>
    <td>{{ Number(props.item.canQty) }}</td>
    <td>{{ props.item.statNm }}</td>
    <!-- <td>
      <template v-if="item.statCd == 'C2'">
        {{ zempName }}
      </template>
    </td> -->
    <td>
      <template v-if="props.item.canQty && props.item.canQty > 0">
        {{ props.item.canName }}
      </template>
      <template v-if="props.item.orderStatusCd == 'C3'">
        {{ props.item.rtrcnRsnCn }}
      </template>
    </td>
    <td>
      <template v-if="props.item.canQty && props.item.canQty > 0">
        {{ props.item.canDate }}<br />{{ props.item.canTime }}
      </template>
      <template v-if="props.item.orderStatusCd == 'C3'">
        {{ props.item.rtrcnDmndDt }}
      </template>
    </td>
  </tr>
</template>

<script setup>
import { onMounted, defineProps, defineEmits, ref, computed } from "vue";
import Utils from "@/js/utils";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
  zempName: {
    type: String,
    require: true,
  },
});

const emit = defineEmits(["detail"]);
const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
//const item = ref(props.item); // 제품
const imageErrorYn = ref(false);

onMounted(() => {});

const productBadgeEmptyYn = computed(() => {
  return (
    props.item.setgdYn !== "Y" &&
    props.item.zzlqdCls !== "A" &&
    props.item.zzlqdCls !== "B" &&
    props.item.zzlqdCls !== "C" &&
    props.item.zzlqdCls !== "D" &&
    props.item.zzlqdtyCls !== "A" &&
    props.item.zzlqdtyCls !== "B" &&
    props.item.zzlqdtyCls !== "C"
  );
});

const isNoPcImage = computed(() => {
  return (
    Utils.isBlank(props.item.filePath) ||
    Utils.isBlank(props.item.physFileNm) ||
    imageErrorYn.value
  );
});

const imageFilePath = computed(() => {
  return FILE_CDN_URL + "/" + props.item.filePath + "/" + props.item.physFileNm;
});
</script>
